export default __webpack_public_path__ + "static/media/Optifo_Full_Logo.2cbdd2a5.svg";